"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var icon_1 = require("../icon");
var lib_1 = require("@ribit/lib");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    type: "text",
    style: "normal",
};
function formatInput(str, format) {
    if (!str) {
        str = "";
    }
    str = str.toString();
    var indexes = [];
    var i = -1;
    var totalFound = 0;
    while ((i = format.str.indexOf(format.separator, i + 1)) >= 0) {
        indexes.push(i - totalFound);
        totalFound++;
    }
    var sepRegex = new RegExp(format.separator, "g");
    str = str.replace(sepRegex, "");
    var maxLength = format.str.replace(sepRegex, "").length;
    var stringList = str.substr(0, maxLength).split("");
    if (!format.characters) {
        format.characters = ".*";
    }
    var suitableCharacters = new RegExp(format.characters);
    var newString = stringList
        .filter(function (value) {
        return suitableCharacters.test(value);
    })
        .map(function (value, index) {
        if (indexes.indexOf(index) > -1) {
            value = format.separator + value;
        }
        return value;
    });
    return newString.join("");
}
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyUp = function (event) {
            var format = _this.props.format;
            if (!format) {
                return;
            }
            event.currentTarget.value = formatInput(event.currentTarget.value, format);
        };
        _this.onChange = function (element) {
            var _a = _this.props, onChange = _a.onChange, name = _a.name, format = _a.format;
            if (onChange) {
                var value = element.target.value;
                if (format) {
                    value = formatInput(value, format);
                }
                onChange(name, value, false, false);
            }
            else {
                (0, lib_1.warn)("".concat(name, " has no onChange method, are you sure this is correct?"));
            }
        };
        return _this;
    }
    Input.prototype.componentDidUpdate = function () {
        var _a = this.props, format = _a.format, value = _a.value, onChange = _a.onChange, name = _a.name;
        if (!format || !onChange) {
            return;
        }
        var formattedInput = formatInput(value, format);
        if (formattedInput !== value) {
            onChange(name, formattedInput, false, true);
        }
    };
    Input.prototype.renderPrefix = function () {
        var _a;
        var _b = this.props, prefix = _b.prefix, prefixClassName = _b.prefixClassName;
        if (!prefix) {
            return null;
        }
        var className = cx((_a = {
                prefix: true
            },
            _a[prefixClassName] = prefixClassName,
            _a));
        return React.createElement("div", { className: className }, prefix);
    };
    Input.prototype.renderIcon = function () {
        var icon = this.props.icon;
        if (!icon) {
            return null;
        }
        return React.createElement(icon_1.Icon, { icon: icon });
    };
    Input.prototype.renderSuffix = function () {
        var suffix = this.props.suffix;
        if (!suffix) {
            return null;
        }
        return suffix;
    };
    Input.prototype.render = function () {
        var _a;
        var _b = this.props, type = _b.type, name = _b.name, lines = _b.lines, className = _b.className, placeholder = _b.placeholder, style = _b.style, autoComplete = _b.autoComplete, error = _b.error, format = _b.format, readonly = _b.readonly;
        var value = this.props.value;
        var control;
        var className_ = cx((_a = {
                outer: true
            },
            _a[style] = true,
            _a[className] = className,
            _a.error = error,
            _a));
        if (!value) {
            value = "";
        }
        if (format) {
            value = formatInput(value, format);
        }
        if (lines > 0) {
            control = (React.createElement("textarea", { name: name, rows: lines, readOnly: readonly, placeholder: placeholder, className: styles.control, onChange: this.onChange, onKeyUp: this.onKeyUp, value: value }));
        }
        else {
            control = (React.createElement("input", { type: type, onChange: this.onChange, readOnly: readonly, autoComplete: autoComplete ? "on" : "off", placeholder: placeholder, name: name, className: styles.control, onKeyUp: this.onKeyUp, value: value }));
        }
        return (React.createElement("div", { className: className_ },
            this.renderPrefix(),
            this.renderIcon(),
            control,
            this.renderSuffix()));
    };
    Input.defaultProps = defaultProps;
    return Input;
}(React.Component));
exports.Input = Input;
exports.default = Input;
//# sourceMappingURL=input.js.map